/**
 * @param {querySelector} burger - burger selector 
 * @param {querySelector} menu - menu selector
 */
export default function initMobilemenu(burgerClass, menuClass) {
    const burger = document.querySelector(".burger")
    if (burger) {
        const menu = document.querySelector(".mobile-menu")
        const menuClose = document.querySelector(".mobile-menu__close")

        burger.addEventListener("click", () => {
            if (body.classList.contains("mobilemenu-opened")) {
                document.removeEventListener("click", outsideEvtListener)
            } else {
                setTimeout(() => {
                    document.addEventListener("click", outsideEvtListener)
                })
            }
            burger.classList.toggle("opened")
            body.classList.toggle("mobilemenu-opened")
        })

        menuClose.addEventListener("click", () => {
            burger.classList.toggle("opened")
            body.classList.toggle("mobilemenu-opened")
            document.removeEventListener("click", outsideEvtListener)
        })

        function outsideEvtListener(evt) {
            if (evt.target === menu || menu.contains(evt.target)) return
            burger.classList.toggle("opened")
            body.classList.toggle("mobilemenu-opened")
            document.removeEventListener("click", outsideEvtListener)
        }

    }

    let userMenuBtn = document.querySelector(".mobile-menu .profile");
    let userMenu = document.querySelector(".mobile-menu__user")
    if (userMenu) {
        let userMenuClose = document.querySelector(".mobile-menu__user-close")

        userMenuBtn.addEventListener("click", () => {
            userMenu.classList.toggle("opened")
        })

        userMenuClose.addEventListener("click", () => {
            userMenu.classList.toggle("opened")
        })
    }

    let subMenuList = document.querySelectorAll(".main-menu .has-submenu");
    if (subMenuList) {
        subMenuList.forEach((submenu) => {
            let subMenuBtn = submenu.querySelector(".submenu-btn")
            let subMenu = submenu.querySelector(".mobile-menu__submenu")
            let subMenuClose = submenu.querySelector(".mobile-menu__submenu-close")

            subMenuBtn.addEventListener("click", () => {
                subMenu.classList.toggle("opened")
            })

            subMenuClose.addEventListener("click", () => {
                subMenu.classList.toggle("opened")
            })
        })
    }
}
